(ns quuppa.re-frame-utils
  (:require [re-frame.core :as rf :refer [subscribe reg-sub]]))

(defn recursive-sub-input-fn [this-key root-query]
  (fn [[_ & ks]]
    (if (seq (butlast ks))
      (subscribe (into [this-key] (butlast ks)))
      (subscribe root-query))))

(defn recursive-sub-query [parent-data [_ & ks]]
  (let [k (last ks)]
    (if (seq ks)
      (if (ifn? k)
        (k parent-data)
        (get parent-data k))
      parent-data)))

(defn reg-recursive-sub [k root-query]
  (reg-sub
    k
    (recursive-sub-input-fn k root-query)
    recursive-sub-query))
